var map = {
	"./blockchain-1.svg": 8846,
	"./bootstrap-5-1.svg": 7706,
	"./express-109.svg": 9368,
	"./framer-motion.svg": 3822,
	"./git-icon.svg": 556,
	"./javascript-1.svg": 8565,
	"./jquery-1.svg": 5113,
	"./jwtio-json-web-token.svg": 1812,
	"./mongodb-icon-1.svg": 7328,
	"./mysql-3.svg": 3599,
	"./next-js.svg": 9408,
	"./nodejs-2.svg": 3844,
	"./react-2.svg": 6945,
	"./sass-1.svg": 2851,
	"./socket-io-1.svg": 2036,
	"./tailwindcss.svg": 2236,
	"./typescript.svg": 7753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5504;